import '../scss/vendor.scss';

import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/dropdown';
